export default __webpack_public_path__ + "static/logzio-tokens-5bba55faf94910f7d01ce6fda8024ba1.png";